module.exports = __webpack_public_path__ + "static/media/icon_2.ff9a6675.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_2.png
// module id = 1896
// module chunks = 0 1